import axios from 'axios'
import qs from 'qs'
import store from '../store'
import router from '../router'
import Vue from 'vue';
import local from './local.js';
let v = new Vue();
let requestNum = 0;
// 创建请求成功后的处理函数
const handleResponse = (response) => {
  // 检查响应头中是否有 authorization
  const authHeader = response.headers['authorization'] || response.headers['Authorization'];
  if (authHeader) {
    // 如果有，更新本地 token
    local.set('token', authHeader);
    console.log('重置token',authHeader)
  }

  // 其他处理逻辑
  requestNum--;
  if(requestNum === 0){
    store.commit('changeShowLoading', false);
  };

  if(response.data && response.data.status === -99){
    if(!isTokenExpiredAlertShown){
      isTokenExpiredAlertShown = true;
      v.$alert(response.data.message, '提示', {
        confirmButtonText: '确定',
        callback: action => {
          if(router.currentRoute.fullPath != '/login'){
            isTokenExpiredAlertShown = false;
            router.replace('/login')
          }
        }
      });
    }
  }else{
    return response;
  }
}
// 响应时间
axios.defaults.timeout = 50 * 1000
// 配置cookie
axios.defaults.withCredentials = false
// 配置post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

axios.defaults.headers.Platform='pc';

axios.defaults.headers.common['Cache-Control'] = 'no-cache'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, Content-Type, Cookie, Accept'
axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, PATCH, PUT, OPTIONS'
axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true'

// 配置接口地址（路径处理函数）考虑跨域情况下
let filterUrl = url =>{
    let baseUrl="/api";
    if (url && url.startsWith("http")) {
    return url;
  }
  return baseUrl + url;
}
var isTokenExpiredAlertShown = false;
// 发送请求
export default {
  get(url, params){
    requestNum++
    if(params && params.hideLoading){
      delete params.hideLoading
      store.commit('changeShowLoading', false);
    }else{
      store.commit('changeShowLoading', true);
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: filterUrl(url),
        headers: {
          "Authorization": local.get('token'),
          "Brand": local.get('brand')
        }
      }).then(res => {
        // 统一处理响应
        handleResponse(res);
        resolve(res);
      }).catch(err => {
        requestNum--;
        if(requestNum === 0){
          store.commit('changeShowLoading', false);
        };
        v.$alert('获取失败', '提示', {
          confirmButtonText: '确定'
        });
        reject(err);
      })
    })
  },
  post(url, params){
    requestNum++
    store.commit('changeShowLoading', true)
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: filterUrl(url),
        data: params,
        paramsSerializer: function (params) {
          return params
        },
        headers: {
          "Authorization": local.get('token'),
          "Brand": local.get('brand')
        }
      }).then(res => {
        // 统一处理响应
        const processedRes = handleResponse(res);
        if(processedRes) {
          resolve(processedRes);
        }
      }).catch(err => {
        requestNum--;
        if(requestNum === 0){
          store.commit('changeShowLoading', false);
        };
        reject(err);
      })
    })
  },
  del(url, params){
    requestNum++
    store.commit('changeShowLoading', true)
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: filterUrl(url),
        data: params,
        paramsSerializer: function (params) {
          return params
        },
        headers: {
          "Authorization": local.get('token'),
          "Brand": local.get('brand')
        }
      }).then(res => {
        // 统一处理响应
        const processedRes = handleResponse(res);
        if(processedRes) {
          resolve(processedRes);
        }
      }).catch(err => {
        requestNum--;
        if(requestNum === 0){
          store.commit('changeShowLoading', false);
        };
        reject(err);
      })
    })
  },
  put(url, params){
    requestNum++
    store.commit('changeShowLoading', true)
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: filterUrl(url),
        data: params,
        paramsSerializer: function (params) {
          return params
        },
        headers: {
          "Authorization": local.get('token'),
          "Brand": local.get('brand')
        }
      }).then(res => {
        // 统一处理响应
        const processedRes = handleResponse(res);
        if(processedRes) {
          resolve(processedRes);
        }
      }).catch(err => {
        requestNum--;
        if(requestNum === 0){
          store.commit('changeShowLoading', false);
        };
        reject(err);
      })
    })
  },
  upload(url, params, isLoading = true){
    requestNum++
    if(isLoading){
      store.commit('changeShowLoading', true)
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: filterUrl(url),
        data: params,
        paramsSerializer: function (params) {
          return params
        },
        headers: {
          "Content-Type": 'application/x-www-form-urlencoded',
          "Authorization": local.get('token'),
          "Brand": local.get('brand')
        }
      }).then(res => {
        // 统一处理响应
        const processedRes = handleResponse(res);
        if(processedRes) {
          resolve(processedRes);
        }
      }).catch(err => {
        requestNum--;
        if(requestNum === 0){
          store.commit('changeShowLoading', false);
        };
        reject(err);
      })
    })
  },
  view_ppt(url, params){
    requestNum++
    store.commit('changeShowLoading', true)
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: filterUrl(url),
        data: params,
        paramsSerializer: function (params) {
          return params
        }
      }).then(res => {
        requestNum--;
        if(requestNum === 0){
          store.commit('changeShowLoading', false);
        };
        resolve(res);
      }).catch(err => {
        requestNum--;
        if(requestNum === 0){
          store.commit('changeShowLoading', false);
        };
        v.$alert('获取失败', '提示', {
          confirmButtonText: '确定'
        });
        reject(err);
      })
    })
  }
}
